"use strict";
(() => {
  // frontend/modules/customers-identity.js
  (function main() {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    if (code) {
      localStorage.setItem("code", code);
      window.location.replace(`/customer_identity/sso_hint?accountnumber=0&provider=customer_identity&return_to=/pages/account`);
    }
  })();
})();
